import React, { useEffect, useState } from "react";
import axios from "../../../api/axios.js";
import {
  convertIntoSelect2Options,
  getFetchOptions,
  uploadImage,
} from "../../../js/utility.js";
import Breadcrumb from "../../utils/Breadcrumb.jsx";
import Select from "react-select";

const EditEvent = () => {
  const [formData, setFormData] = useState({});
  const [provOptions, setProvOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [ldcOptions, setLdcOptions] = useState([]);
  const [ldcFullData, setLdcFullData] = useState([]);
  const [image, setImage] = useState(null);

  const breadcrumb = {
    current_section: "Eventi",
    sections: [
      { name: "Eventi", route_name: null, params: [] },
      { name: "Modifica", route_name: null, params: [] },
    ],
  };

  useEffect(() => {
    const fetchProvs = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/provincie`,
          fetchOptions
        );
        const result = await response.json();
        result.provincie.sort((a, b) => a.nome.localeCompare(b.nome));
        setProvOptions(
          convertIntoSelect2Options(result.provincie, "id", "nome")
        );
      } catch (error) {
        console.error(error);
      }
    };

    const fetchLDCs = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/ldc/ldcget`,
          fetchOptions
        );
        const result = await response.json();

        setLdcOptions(
          convertIntoSelect2Options(result.return.ldc, "id", "nome")
        );
        setLdcFullData(result.return.ldc);
      } catch (error) {
        console.error(error);
      }
    };

    const fetchFormData = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${
            axios.defaults.baseBFFUrl
          }/fe/getEvent?eventId=${window.location.pathname.split("/").pop()}`,
          fetchOptions
        );
        const result = await response.json();
        setFormData(result);
      } catch (error) {
        console.error(error);
      }
    };

    fetchProvs();
    fetchLDCs();
    fetchFormData();
  }, []);

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/app/getTowns?idprov=${formData.idprovincia}`,
          fetchOptions
        );
        const result = await response.json();

        setCityOptions(convertIntoSelect2Options(result, "id", "nome"));
      } catch (error) {
        console.error(error);
      }
    };
    fetchCities();
  }, [formData.idprovincia]);

  useEffect(() => {
    const fetchFilteredLDCs = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getAllLDC?provinceId=${
            formData.idprovincia ?? ""
          }&townId=${formData.idcomune ?? ""}`,
          fetchOptions
        );
        const result = await response.json();
        setLdcOptions(convertIntoSelect2Options(result, "id", "nome"));
      } catch (error) {
        console.error(error);
      }
    };
    fetchFilteredLDCs();
  }, [formData.idprovincia, formData.idcomune]);

  const handleProvinceChange = (e) => {
    setFormData((prevData) => ({ ...prevData, idprovincia: e?.value }));
    setFormData((prevData) => ({ ...prevData, idcomune: null }));
    setCityOptions([]);

    const fetchCities = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/app/getTowns?idprov=${e?.value}`,
          fetchOptions
        );
        const result = await response.json();
        setCityOptions(convertIntoSelect2Options(result, "id", "nome"));
      } catch (error) {
        console.error(error);
      }
    };
    fetchCities();
  };

  const handleCityChange = (e) => {
    setFormData((prevData) => ({ ...prevData, idcomune: e?.value }));
  };

  const handleLDCChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      idldc: e?.value,
      longitude: ldcFullData.find((ldc) => ldc.id == e?.value)?.longitude,
      latitude: ldcFullData.find((ldc) => ldc.id == e?.value)?.latitude,
      indirizzo: ldcFullData.find((ldc) => ldc.id == e?.value)?.indirizzo,
      idMuseo: e?.value,
    }));
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleImageUpload = () => {
    if (!image) {
      alert("Seleziona un'immagine da caricare.");
      return;
    }
    const file = image;

    if (file) {
      uploadImage(file)
        .then(async (url) => {
          const fetchOptions = getFetchOptions(
            "application/json",
            { eventId: formData.id, tokenimg: url },
            "PUT"
          );
          const response = await fetch(
            `${axios.defaults.baseBFFUrl}/fe/updateEventCover`,
            fetchOptions
          );
          const result = await response.json();
          if (result.error) {
            alert("Errore durante il caricamento dell'immagine. Riprova.");
            return;
          }

          alert("Immagine del luogo aggiornata con successo!");
          window.location = `/events`;
        })
        .catch((error) => {
          console.error("Error uploading image:", error);
        });
    }
  };

  const handleSave = () => {
    if (!formData.idprovincia) {
      alert("Il campo Provincia è obbligatorio.");
      return;
    }
    if (!formData.idcomune) {
      alert("Il campo Comune è obbligatorio.");
      return;
    }
    if (!formData.datainizio) {
      alert("Il campo Data inizio è obbligatorio.");
      return;
    }
    if (!formData.orainizio) {
      alert("Il campo Ora inizio è obbligatorio.");
      return;
    }
    if (!formData.datafine) {
      alert("Il campo Data fine è obbligatorio.");
      return;
    }
    if (!formData.orafine) {
      alert("Il campo Ora fine è obbligatorio.");
      return;
    }
    if (!formData.nomeevento) {
      alert("Il campo Titolo è obbligatorio.");
      return;
    }
    if (!formData.longitude) {
      alert("Il campo Longitudine è obbligatorio.");
      return;
    }
    if (!formData.latitude) {
      alert("Il campo Latitudine è obbligatorio.");
      return;
    }
    if (!formData.indirizzo) {
      alert("Il campo Indirizzo è obbligatorio.");
      return;
    }

    if (formData.datainizio > formData.datafine) {
      alert("La data di inizio non può essere successiva alla data di fine.");
      return;
    }

    const fetchOptions = getFetchOptions(
      "application/json",
      {
        eventId: window.location.pathname.split("/").pop(),
        eventData: { ...formData },
      },
      "PUT"
    );
    fetch(`${axios.defaults.baseBFFUrl}/fe/updateEvent`, fetchOptions).then(
      () => {
        window.location = "/events";
      }
    );
  };

  return (
    <div className="container-fluid">
      {/* Breadcrumb */}
      <Breadcrumb breadcrumb={breadcrumb} />

      <a href="/events">
        <button className="btn btn-primary mb-4">
          <i className="bi bi-arrow-left"></i> Torna alla lista eventi
        </button>
      </a>

      {/* Event Management */}
      <div className="card custom-card">
        <div className="card-header">Dati generali</div>
        <div className="card-body">
          <div className="row row-cols-1 row-cols-lg-3 mb-3">
            <div className="col">
              <label htmlFor="province">
                Provincia <b>*</b>
              </label>
              <Select
                options={provOptions}
                id="province"
                name="province"
                value={provOptions.filter(function (option) {
                  return option.value === Number(formData.idprovincia);
                })}
                onChange={handleProvinceChange}
                classNames={"form-control"}
                placeholder="Scegli provincia..."
                isSearchable
                isClearable
              />
            </div>
            <div className="col">
              <label htmlFor="city">
                Comune <b>*</b>
              </label>
              <Select
                options={cityOptions}
                id="city"
                name="city"
                value={cityOptions?.filter(function (option) {
                  return option.value === Number(formData.idcomune);
                })}
                onChange={handleCityChange}
                classNames={"form-control"}
                placeholder="Scegli comune..."
                isSearchable
                isClearable
              />
            </div>
            <div className="col">
              <label htmlFor="idldc">Luogo della cultura</label>
              <Select
                options={ldcOptions}
                id="idldc"
                name="idldc"
                value={ldcOptions?.filter(function (option) {
                  return option.value === Number(formData.idldc);
                })}
                onChange={handleLDCChange}
                classNames={"form-control"}
                placeholder="Scegli luogo..."
                isSearchable
                isClearable
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-6 col-lg-2">
              <label htmlFor="datainizio">
                Data inizio <b>*</b>
              </label>
              <input
                id="datainizio"
                name="datainizio"
                type="date"
                className="form-control"
                value={formData.datainizio || ""}
                onChange={(e) =>
                  handleInputChange("datainizio", e.target.value)
                }
              />
            </div>
            <div className="col-6 col-lg-2">
              <label htmlFor="orainizio">
                Ora inizio <b>*</b>
              </label>
              <input
                id="orainizio"
                name="orainizio"
                type="time"
                className="form-control"
                value={formData.orainizio || ""}
                onChange={(e) => handleInputChange("orainizio", e.target.value)}
              />
            </div>
            <div className="col-6 col-lg-2">
              <label htmlFor="datafine">
                Data fine <b>*</b>
              </label>
              <input
                id="datafine"
                name="datafine"
                type="date"
                className="form-control"
                value={formData.datafine || ""}
                onChange={(e) => handleInputChange("datafine", e.target.value)}
              />
            </div>
            <div className="col-6 col-lg-2">
              <label htmlFor="orafine">
                Ora fine <b>*</b>
              </label>
              <input
                id="orafine"
                name="orafine"
                type="time"
                className="form-control"
                value={formData.orafine || ""}
                onChange={(e) => handleInputChange("orafine", e.target.value)}
              />
            </div>
            <div className="col-12 col-lg-4">
              <label htmlFor="nomeevento">
                Titolo <b>*</b>
              </label>
              <input
                id="nomeevento"
                name="nomeevento"
                type="text"
                value={formData.nomeevento || ""}
                onChange={(e) =>
                  handleInputChange("nomeevento", e.target.value)
                }
                className="form-control"
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-6 col-lg-3 col-xl-2">
              <label htmlFor="longitudine">
                Longitudine <b>*</b>
              </label>
              <input
                id="longitudine"
                name="longitudine"
                type="text"
                className="form-control"
                value={formData.longitude || ""}
                onChange={(e) => handleInputChange("longitude", e.target.value)}
              />
            </div>
            <div className="col-6 col-lg-3 col-xl-2">
              <label htmlFor="latitudine">
                Latitudine <b>*</b>
              </label>
              <input
                id="latitudine"
                name="latitudine"
                type="text"
                className="form-control"
                value={formData.latitude || ""}
                onChange={(e) => handleInputChange("latitude", e.target.value)}
              />
            </div>
            <div className="col-12 col-lg-6 col-xl-8">
              <label htmlFor="indirizzo">
                Indirizzo <b>*</b>
              </label>
              <input
                id="indirizzo"
                name="indirizzo"
                type="text"
                className="form-control"
                value={formData.indirizzo || ""}
                onChange={(e) => handleInputChange("indirizzo", e.target.value)}
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-12">
              <label htmlFor="eventidescrizione">Breve descrizione</label>
              <textarea
                id="eventidescrizione"
                name="eventidescrizione"
                className="form-control"
                value={formData.eventidescrizione || ""}
                onChange={(e) =>
                  handleInputChange("eventidescrizione", e.target.value)
                }
              ></textarea>
            </div>
          </div>

          {/* Save Button */}
          <div className="saveButtonContainer">
            <button
              id="savePlaceBtn"
              name="savePlaceBtn"
              className="btn btn-success saveButton"
              type="button"
              onClick={handleSave}
            >
              &nbsp;Salva
            </button>
          </div>
        </div>
      </div>

      {/* Images */}
      {formData && (
        <div className="card custom-card">
          <div className="card-header">Carica cover</div>
          <div className="card-body">
            <div className="input-group">
              <input
                type="file"
                className="form-control"
                id="inputGroupFile04"
                aria-describedby="inputGroupFileAddon04"
                aria-label="Upload"
                onChange={(e) => setImage(e.target.files[0])}
              />
              <button
                className="btn btn-success"
                type="button"
                id="inputGroupFileAddon04"
                onClick={handleImageUpload}
              >
                <i className="bi bi-file-excel-fill"></i> Importa
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditEvent;
